import pulseTracker from '@finn-no/pulse-sdk';

function trackButtonClick({
    adId,
    title,
    trackingCategory,
    type,
    vertical,
    trackingObjectName,
}) {
    const trackingObject = {
        type: 'Click',
        intent: 'Create',
        name: 'Send message',
        object: {
            id: 'sendMessageButton',
            type: 'UIElement',
            elementType: 'Button',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: adId,
                    contentId: adId,
                    name: title,
                    category: trackingCategory,
                    listingType:
                        type === 'MESSAGING'
                            ? 'private'
                            : type === 'EMAIL'
                              ? 'professional'
                              : 'n/a',
                },
            ],
            page: {
                type: 'ClassifiedAd',
            },
        },
        target: {
            id: 'id',
            type: 'Message',
        },
        vertical: {
            name: vertical,
        },
    };

    if (trackingObjectName) {
        trackingObject.object.name = trackingObjectName;
    }

    pulseTracker.trackEvent(trackingObject);
}

function trackButtonClickUserMustVerify({
    adId,
    title,
    trackingCategory,
    type,
    vertical,
    trackingObjectName,
}) {
    const trackingObject = {
        type: 'Click',
        intent: 'Attempt',
        name: 'eID - verification',
        object: {
            id: 'sendMessageButton',
            type: 'UIElement',
            elementType: 'Button',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: adId,
                    contentId: `${adId}`,
                    name: title,
                    category: trackingCategory,
                    listingType:
                        type === 'MESSAGING'
                            ? 'private'
                            : type === 'EMAIL'
                              ? 'professional'
                              : 'n/a',
                },
            ],
            page: {
                type: 'ClassifiedAd',
            },
        },
        target: {
            id: 'id',
            type: 'Message',
        },
        vertical: {
            name: vertical,
        },
    };

    if (trackingObjectName) {
        trackingObject.object.name = trackingObjectName;
    }

    pulseTracker.trackEvent(trackingObject);
}

export { trackButtonClick, trackButtonClickUserMustVerify };
